module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.91580017.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }